var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrandmaconfused1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_4",
    "data-name": "Layer 4",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 405.72 442.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #5f6060;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9 {\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 3px;\n      }\n\n      .cls-1, .cls-2, .cls-6, .cls-8 {\n        stroke: #5f6060;\n      }\n\n      .cls-2, .cls-3 {\n        fill: none;\n      }\n\n      .cls-3 {\n        stroke: #5f6161;\n      }\n\n      .cls-4 {\n        fill: #aaa;\n        stroke: #ababab;\n      }\n\n      .cls-5 {\n        fill: #e8e8e8;\n        stroke: #e8e8e8;\n      }\n\n      .cls-6 {\n        fill: #606161;\n      }\n\n      .cls-7 {\n        fill: gray;\n        stroke: gray;\n      }\n\n      .cls-8 {\n        fill: #898989;\n      }\n\n      .cls-9 {\n        fill: #bebebe;\n        stroke: #bebebe;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Body_Colour",
    "data-name": "Body Colour"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "210.06 228.34 216.72 275.72 251.27 294.81 303.53 279.86 293.76 222.39 236.95 213.03 210.06 228.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M218.43,270.14s22.08,16.4,38.88,12.53,37.2-13.38,39.6-23.51,2.28,181.46,2.28,181.46l-83.81-2.42,3.05-168.06h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M254.02,272.55c7.41.4,10.27-4.38,14.81-7.13s10.78-3.47,12.3-2.72c0,0-12.96,17.56-28.37,17.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M281.24,218.99s15.66,12.96,15.66,18.87c0,12.86,3.73,44.46-2.98,74.02-6.71,29.57,1.98,101.81,0,114.18s43.63-1.78,43.63-1.78c0,0-2.48-56.85-8.69-70.05s3.23-46.54,3.23-46.54c0,0,3.16,8.82,3.78,25.59s9.14,27.14,9.14,27.14c0,0,2.6,23.49,6.69,31.72s0,34.02,0,34.02l50.25-2.1s-11.63-46.66-10.86-58.24l-10.35-12.42s2.26-20.52,1.89-23.7-14.05-33.04-14.05-33.04l1.38-18.89s-14.83-1.22-14.81-9.72c.03-8.5.42-20.1.42-20.1l-12.84-15.24-53.11-18.35-8.38,4.61v.02Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M254.02,272.55c-7.41.4-10.27-4.38-14.81-7.13s-10.78-3.47-12.3-2.72c0,0,12.96,17.56,28.37,17.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M179.83,295.44s5.57,45.59-.64,58.79-8.69,70.05-8.69,70.05c0,0,45.6,14.15,43.63,1.78s6.71-84.61,0-114.18-2.98-61.16-2.98-74.02c0-5.91,15.66-18.87,15.66-18.87l-8.38-4.61-53.11,18.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M231.17,228.12s13.75,13.34,17.11,14.43,4.25,10.28,5.34,11.66,2.57-11.86,6.03-11.37,4.77,2.64,4.77,2.64l-1.31,16.15s3.76-4.55,10.48-6.92,20.17-14.23,20.17-14.23c0,0-3.36-10.18-6.62-13.54s-7.12-5.92-7.12-5.92l-51.35-4.01,2.51,11.12h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M230.69,233.95s-12.98,7.32-15.69,25.21l-2.96-5.96s6.29-23.99,9.75-26.66,5.54-4.15,5.54-4.15l3.36,11.57h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M237.23,231.95s4,18.42,0,19.47-8.56.42-8.56.42l14.22,8.42,2.35,3.7s-1.13-19.74-8.01-32.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M286.5,363.16s-3.62,11.83-12.79,5.07-43.33-33.25-52.34-98.08l-9.32-10.98s-5.76,48.6,21.07,84.08,31.66,35.48,39.14,37.65c12.65,3.67,14.24-17.74,14.24-17.74h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M277.57,399.96s-10.14-9.17-30.17-15.93c-20.03-6.76-26.03-63.79-26.03-63.79l-2.94-.23s1.15,38.92-1.44,58.96c0,0-3.62,31.13,0,44.41s53.58,1.93,53.58,1.93c0,0-40.31-11.34-35.72-19.55s42.72-5.79,42.72-5.79h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M179.83,298.64l.8,45.9,8.5-40.29s-4.28,12.6-5.55,7.75-1.98-23.96-8.03-32.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M318.73,302.44l-4.88-17.09s9.32,26.42,11.99,21.98,5.11-14.65,5.11-14.65l-3.11,52.62-9.1-42.85h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M332.49,283.57s1.78,19.31,5.11,23.98c0,0,6.27-1.42,5.88-17.75-.02-.78-.05-1.6-.1-2.45-1.11-18.65,7.1,23.09-1.33,43.74,0,0,2.89,5.55,2.89,9.32s-.89,18.87,3.55,24.87c0,0-.94,12.54-1.09,20.43-.01.7-.02,1.37-.02,1.99,0,7.55-8.44-38.63-9.55-49.95s-7.99-25.53-7.99-25.53l2.66-28.64h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M356.14,263.97s1.41,5.04-1.12,13.7,6.46,19.06,6.46,22.72,4.78,8.15-1.41,22.77c-6.19,14.62-6.61,13.77-11.6,28.11,0,0,12.44-23.84,17.22-23.02,0,0,.28,10.09,2.53,13.19s4.18,6.15,4.22,11.52c.15,21.96-16.02,24.49-15.46,35.57s20.8-9.15,23.89-15.05c0,0-7.59,15.46-6.46,25.86s16.3,13.21,16.3,22.21l10.68-1.12s-10.12-37.66-10.4-52.28l-11.24-14.9,3.65-23.61s-12.37-9.84-14.33-35.13l1.12-14.9s-10.96,1.92-14.05-15.62v-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M313.3,222.39s-11.3,1.05-13.29,7.97-4.74,11.05-4.74,11.05c0,0-3.06-12.83-10.54-19.02l-3.06-4.66,2.09-7.77,29.53,12.43h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M206.59,217s11.91-.75,12.37,4.01-3.95,14.25-3.95,14.25c0,0,3.07-11.7,8.68-13.56s10.14-5.67,10.14-5.67l-6.26-6.08-20.98,7.05h0Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Body_Lines",
    "data-name": "Body Lines"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M273.36,225.55s-11.78,17.15-11.7,39.87c0,0,2.91-3.76,4.36-5.15s16.46-6.15,27.9-17.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M281.24,217s-7.61,16.86-2.73,26.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M281.24,221.01s5.32,2.86,9.58,9.34c4.25,6.48,12.28,37.9,2.6,76.64s3.48,78.59-.37,112"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M288.18,212.04s51.36,19.16,54.54,20.68,13.58,10.86,14.85,16.16-1.7,13.58,0,19.73,12.09,7.43,13.58,10.4-6.37,36.5-12.31,49.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M369.95,291.96s5.13,26.41,13.62,36.28c3.07,3.57-1.17,20.37-.95,24.19s8.91,10.19,8.91,15.7,5.96,37.81,10.41,53.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M342.87,234.05s-7.45,39.79-13.11,53.06c0,0-1.64,56.81-.5,68.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M318.92,304.26c-.44-1.65,3.47,28.81,10.33,51.31,4.5,14.75,8.29,63.43,8.29,63.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M329.76,314.83s5.85,12.56,6.1,18.44,2.21,22.29,7.01,27.76c0,0,1.35,23.79,7.22,33.68,0,0,2.23,12.32,1.42,24.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M254.02,281.13c26.03,0,41.7-20.66,42.87-28.44"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M233.83,222.61s12.64,20.09,12.56,42.81c0,0-2.91-3.76-4.36-5.15s-16.46-6.15-27.9-17.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M226.81,217s7.61,16.86,2.73,26.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M226.81,221.01s-5.32,2.86-9.58,9.34-12.28,37.9-2.6,76.64-3.48,78.59.37,112"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M165.33,232.72c3.18-1.52,54.54-20.68,54.54-20.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M165.18,234.05s7.45,39.79,13.11,53.06c0,0,1.64,56.81.5,68.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M189.12,304.26c.44-1.65-3.47,28.81-10.33,51.31-4.5,14.75-8.29,63.43-8.29,63.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M254.02,281.13c-26.03,0-41.7-20.66-42.87-28.44"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Head_Colour",
    "data-name": "Head Colour"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M186.23,207.17s.78,9.23,3.42,11.59,9.78,6.39,14.48.33,7.2-10.42,7.2-10.42c0,0,6.2,8.47,10.83,9.28s16.02,4.31,16.02,4.31l14.55,6.61,15.24-3.71,11.97-9.19,4.96-15.01,9.96-15.28s11.98-4.9,13.08-6.25-.49-15.96-.49-15.96l2.08-5.17s10.52-7.44,8.4-12.28-4.91-5.94-4.91-5.94c0,0,6.75-1.33,8.42-5.44s2.02-6.52-.38-11.37c0,0,1.75,6.44-3.07,8.25s-7.38,3.2-9.27-2.54-5.08-12.46-5.08-12.46c0,0,4.74-13.45,2.9-16.92s-6.89-5.5-13.98-8.3-6.49-7.04-6.49-7.04c0,0,.21-6.45,3.41-7.23,0,0-6.55,0-9.95,1.32,0,0-2.46-11.95-5.17-13.75s-12.03-4.74-18.71-.48-9.05,11.98-9.05,11.98l-7.79,1.05-3.06-10.65,7.84-4.12,3.71.59-7.48-6.71-13.2,3.08-5.88,6.5-8.48-8.89-3.94.81,2.8,8.88s-14.56,8.37-21.7,10.43c-12.34,3.56-9.84,22.74-9.84,22.74l-9.53,1.06s-7.93,2.01-10.37,10.03-3.11,13.13-.95,18.06,3.43,5.55,3.43,5.55c0,0-11.46,2.7-12.9,8.87s5.65,13.97,10.33,16.78c4.68,2.8,6.65,8.77.84,11.89-5.8,3.12-12.86.4-12.86.4,0,0,2.61,6.94,6.57,7.86s10.86-3.94,10.86-3.94c0,0-3.96,10.7-5.43,16.25s.7,16.15,8.03,15.66,18.63-1.11,18.63-1.11h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M278.74,140.84s-10.53,12.47-24.07,13.65c0,0,12.78-1.08,18.59-6.36,5.25-4.77,5.47-7.3,5.47-7.3h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M300.63,137.86s2.67,7.56,2.52,10.69c-.15,3.13-1.72,10.04-3.9,10.86,0,0,2.3-8.27,1.84-9.51s-5.68-10.26-5.13-11.88,2.51-3.27,2.51-3.27l2.16,3.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M276.55,148.08s5.11,9.36,4.82,15.11c0,0,3.14,4.34,3.7,6.21,0,0,2.63-3.2.89-9.24-.84-2.93-3.08-5.85-5.15-8.09-.58-.62,3.79-3.83,3.69-6.4-.06-1.57-4.54-2.96-4.82-3.21-1.01-.92-3.12,5.62-3.12,5.62h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M250.15,184.6s4.97-5.5,8.74-5.38,4.13,1.68,4.13,1.68c0,0-7.48,6.43-11.3,7.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M234.57,120.84s-3.66,7.42-1.07,10.53,6.07,1.89,6.07,1.89c0,0-6.4-3.51-5-12.41h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M237.19,111.78s-3.91,6.1-11.24,8.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M273.49,164.84s.75,7.97,4.24,11.29,9.54,9.75,6.73,14.58-6.16-1.92-6.16-1.92l-10.2,3.13s9.02-1.32,10.42,1.62,2.32,21.08,2.32,21.08c0,0,4.6-11.45,6.08-13.94,7.47-12.59,8.66-25.2,7.16-36.04,0,0-3.24,20.4-4.58,16.83-.92-2.45-13.21-9.1-16-16.64h-.01Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M199.83,170.48s16.14,2.46,27.11-5.57c0,0-10.33,7.6-18.18,7.46-7.09-.13-8.92-1.89-8.92-1.89h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M181.39,182.65s2.96,7.45,5.14,9.7,7.9,6.43,10.09,5.61c0,0-7.17-4.71-7.64-5.95s-2.48-11.46-3.96-12.32-4.05-.81-4.05-.81l.41,3.76h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M206.24,174.48s2.32,10.41,6.32,14.54c0,0,.49,5.33,1.3,7.11,0,0-4.08-.67-6.75-6.37-1.29-2.76-1.54-6.43-1.45-9.48.03-.85-5.37-.39-6.99-2.39-.99-1.22,1.47-5.21,1.51-5.58.15-1.36,6.05,2.18,6.05,2.18h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M250.15,184.6s-7.37-.87-10.12,1.7-2,3.98-2,3.98c0,0,9.86-.09,13.68-1.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M219.91,126.35s7.64,3.18,7.73,7.22-3.33,5.42-3.33,5.42c0,0,2.51-6.86-4.41-12.64h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M211.97,121.26s6.96,2.02,13.98-1.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M219.57,185.09s4.68,6.49,4.24,11.29-.77,13.62,4.53,15.41,4.58-8.06,4.58-8.06l9.7,1.82s-8.33,3.24-7.45,6.37,11.64,15.48,11.64,15.48c0,0-10.99-5.59-13.75-6.49-13.91-4.56-23.11-13.27-29.11-22.42,0,0,15.87,13.22,14.53,9.65-.92-2.45,3.95-15.55,1.09-23.06h0Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M242.65,132.1s-3.31,11.02-2.8,12.39,5.95,20.11,7.4,22.92,6.51,7.34,6.76,9.8-3.86,7.39-3.86,7.39c0,0,12.83-1.37,12.88-5.15s-.22-6.02-.22-6.02c0,0-11.3-7.17-14.01-19.39l3.05-2.94-1.36-5.19,7.32-6.5s-3.86,2.28-3.25-12.79c.02-.53-.13-1.05-.15-1.57-.34-7.69-11.76,7.04-11.76,7.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M261.94,121.43s7.78,7.56,14.31,11.39c6.53,3.84,2.76,12.54,2.76,12.54l2.74,20.05s4.67,8.06,4.36,11.62,5.69.79,5.69.79c0,0,1.34,9.72,5.17,8.07s13.72-2.82,11.96-9.5c-1.76-6.68-1.18-15.89-1.18-15.89,0,0,10.06-7.5,9.71-10.82s-3.65-9.71-3.65-9.71c0,0,9.43-1.6,9.23-6.91s-1.52-10.41-1.52-10.41c0,0-.58,8.41-4.86,9.77s-6.15,1.16-9-6.83c-2.85-7.99-4.29-9.84-4.29-9.84,0,0,6.76-4.33,3.8-12.21-2.96-7.87-7.74-11.03-10.67-12.35s-9.06-5.65-9.06-5.65c0,0,2.15,16.27-5.71,17.25-7.86.99-12.43-9.61-12.43-9.61,0,0-9.32,17.46-13.85,13.77s-5.26-9.2-5.26-9.2c0,0,1.51-7.31.52-9.08,0,0-3.96,4.61-10.29,2.5.21,6.96-3.7,11.97-7.93,16.83,0,0,6.31,15.28,13.19,12.39s16.26,1.04,16.26,1.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M230.67,109.26s-10.91,8.64-13.55,10.55-8.51,4.11-9.48,5.89c-4.79,8.77,8.56.87,12.28.65-3.89.4-16.57,8.51-16.28,10.45.29,1.95,2.27,17.41-4.28,19.54s-14.43,10.45-14.43,10.45l-3.22-8.57s16.74-10.75,14.35-19.2-3.28-16.2,1-17.14,10.64,1.46,10.64,1.46c0,0-1.45-8.4,3.54-9.97s13.59.45,19.43-4.11h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M194.25,97.03s.14,9.83,6.33,12.75,10.66,3.59,10.66,3.59l-5.94,9.22-8.76-2.09s-1.82-5.39-6.77-8.95-10.55-2.44-14.69.59-8.67-9.91,2.62-12.7c0,0,.93,5.46,6.83,3.57s9.72-5.98,9.72-5.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M164.7,136.42l-7.44-8.55s5.06,5.12,8.34,1.64,6.46,1.01,6.46,1.01c0,0,2.9,11.14-.42,12.22s-6.94-6.31-6.94-6.31h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M163.16,140.07s3.39,25.88,5.3,27.87,5.04,3.13,5.04,3.13c0,0,.34-3.03,1.54-3.48s7.8.57,7.8.57l-1.45-10.79c-21.59-4.75-4.31-23.03-18.22-17.31h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M191.5,204.54s2.85,14.82,6.9,14.77,9.39-3.37,9.39-3.37l3.07-5.47-4.14-5.82s-2.63,7.53-6.06,5.37-9.16-5.47-9.16-5.47h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M205.48,92.1s-2.18,2.59,1.7,6.56,14.59.49,13.96-2.96-2.31-9.67-5.91-8.86-9.75,5.26-9.75,5.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M230.08,74.84l3.04,1.47,4.58-1.72s-2.93-8.14.61-9.64,11.41-1.35,11.41-1.35c0,0-6.94-7.97-12.65-6.94-5.71,1.03-16.01,4.52-20.7,14.49l13.72,3.68h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M247.26,72.23s7.96-9.95,15.25-10.07,13.03,2.9,14.7,7.33,1.7,7.21,1.7,7.21c0,0-9.74,6.62-9.67,11.55,0,0-2.81-12.26-9.09-14.13s-12.88-1.89-12.88-1.89h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M209.35,65.71s2.58-2.45,4.6-.96c1.89,1.4,2.18,4.79,1.72,5.25l3.92-7.06s-6.33-5.84-11.27-5.18c0,0,3.73,5.4,1.03,7.96h0Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-7",
    points: "213.38 158.74 215.83 164.99 223.51 161.11 222.62 156.4 213.38 158.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "266.18 137.88 268.74 144.71 277.24 140.18 276.63 135.8 266.18 137.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M242.23,117.84s-7.26,1.63-8.13,4.06"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Head_Lines",
    "data-name": "Head Lines"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M260.18,181.4s-1.92-.17-3.4,2.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M283.45,116.36s4.8,8.02,6.36,14.76c1.57,6.74,5.53,23.97,4.79,33.32s3.02,17.3,1.11,22.98c-1.92,5.69-9.42,16.03-9.42,16.03,0,0-5.02,13.85-7.67,16.58s-8.67,6.34-12.28,7.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M276.63,146.88s7.83,5.94,9.12,9.89,1.34,6.64,1.34,6.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M281.3,141.84s8.12,6.21,9.9,6.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M271.85,149.25s-1.2,1.22-3.9,2.63-13.91,2.86-13.91,2.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M257.78,134.91s-7.56,1.64-6.45,11.56c0,0,2.18-4.39,10.21-7.85s16.9-3.2,16.9-3.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M235.47,124.22s-.57,7.43,4.11,9.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M246.17,142.33c-3.17,2.72-3.9,4.69-2.32,7.22s6.51,11.76,9.74,11.82,30.43-7.09,32.86-15.81,1.61-15.47-1.04-17.98-27.07,4.3-39.25,14.74h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M238.09,152.5c3.79-1.42,6.5-.5,6.5-.5l-1.51-2.04s-3.45.04-5.62.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M289.71,129.69s3.55-6.33,6.95-6.32,13.26,14.28,12.07,24.69c-1.19,10.41-4.01,27.34-13.28,21.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M301.04,137.08s-2.61-4.86-4.19-2.81-2.73,8.52,2.3,15.36c2.32,3.16-.2,5.83-.78,9.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M278.45,140.18s-3.48,5.06-7.69,6.16-11.18,2.22-16.66,4.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M265.25,182.66s16.74,5.81,17.83,9.51-.6,7.41-.6,7.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M240.49,188.8s1.34-1.4,4.26-.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M180.64,158.62s1.19,5.73,4.45,11.84,11.62,21.69,18.32,28.24,9.11,15.01,14.3,18.03,17.64,5.87,17.64,5.87c0,0,12.9,7.12,16.68,7.43s10.71-.93,14.32-2.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M205.39,173.63s-1.98,9.62-.35,13.45,3.36,5.88,3.36,5.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M198.56,172.92s-2.02,10.02-3.29,11.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M210.54,172.27s1.71.12,4.67-.59,12.36-7,12.36-7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M211.69,152.22s6.77-3.74,12.47,4.45c0,0-4.53-1.87-12.85.81s-14.83,8.72-14.83,8.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M221.46,129.48s5.32,5.21,2.86,9.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M225.32,150.16c4.18-.04,6.02.96,6.5,3.91s2.84,13.14.45,15.32-27.57,14.7-35.15,9.73c-7.58-4.97-11.39-10.58-11.05-14.21s23.2-14.58,39.25-14.74h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M238.09,152.5c-3.79,1.42-5.22,3.9-5.22,3.9l-.2-2.54s2.62-2.24,4.79-3.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M184.23,169.31s-6.84-2.43-9.4-.18-.58,19.48,7.17,26.53c7.75,7.05,21.02,17.94,24.1,7.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M180.56,182.33s-1.23-5.37,1.3-4.87c2.53.5,7.66,4.62,8.38,13.07.33,3.9,3.99,4.25,6.86,6.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M199.6,169.79s5.96,1.52,9.85-.43,9.88-5.69,15.59-7.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M231.72,207.89s19.11-3.21,24.31-7.64c11.9-10.12,19.18-11.24,22.27-11.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M237.51,193.08s-8.77,15.4-7.17,18.89,5.33,5.19,5.33,5.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M191.86,149.25s22.82-5.02,30.9-10.26c0,0-1.9-5.65-2.82-4.75-12.22,11.93-25.43,10.77-25.43,10.77l-2.65,4.25h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M275.04,117.52s-17-1.16-34.01,14.8c0,0-3.2-4.65-2.07-5.26,20.16-10.71,30.62-10.71,30.62-10.71l5.46,1.16h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M221.06,63.57c-8.01-12.7-15.42-5.71-15.42-5.71,13.97,13.05-12.29,12.55-23.16,21.98-5.69,4.93-4.78,19.61-4.78,19.61,0,0-14.38-2.99-20.03,12.68-5.65,15.68,3.23,21.76,3.23,21.76,0,0-16.42,4.08-12.4,15.76s16.8,9.63,12.23,19.4c-4.57,9.78-15.52.15-15.52.15,0,0,3.24,22.78,19.63,8.38,0,0-12.71,21.26-3.26,28.88s24.26,1.33,24.26,1.33c0,0-1.8,11.67,7.78,15.21s17.09-7.88,18.23-12.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M213.17,74.47s9.01-15.69,17.65-18.12,16.78-1.45,19.7,9.77c0,0-4.72-4.38-9.95-.63s-1.33,9.4-1.33,9.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M246.62,72.11s3.09-8.05,14.17-10.99c10.31-2.74,17.71,1.45,18.97,13.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M213.12,100.91s16.03-3.62,6.66-12.31c-9.1-8.44-15.04,3.77-15.04,3.77-1.5-16.3,12.92-24.63,26.08-16.24,13.16,8.39,8.64,26.26,2.47,30.17-12.26,7.75-14.87,4.27-21.38,6.16s-5,11.31-5,11.31c0,0-6.08-5.5-11.58-1.6s2.36,17.98-1.87,23.79-9.73,14.1-18.94,11.51c-9.21-2.58-18.43-11.53-9.81-21.05,0,0,2.47,15.26,8.7,5.89,4.69-7.06-5.16-13.74-2.83-22.16,2.33-8.43,10.94-12.32,16.47-10.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M235.39,77.78s11.63-7.73,22.64-3.54,17.55,29.48,2.94,37.37-22.41,3.61-29.16-4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M244.4,82.32s10.01,4.93,6.01,13.47-13.89,8.92-13.89,8.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M269.87,91.71s5.84-23.53,23.7-15.05c0,0-15,2.93-3.69,25.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M264.05,109.43s8.05,15.99,26.39,2.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M286.07,84.27s6.75,6.78,13.21,7.61,13.28,9.84,5.86,24.75c0,0,3.25.95,4.86,10.29,1.61,9.34,12.9,3.29,8.66-8.5,0,0,15.8,14.14-2.84,22.77,0,0,11.5,6.53-6.81,19.92,0,0-.89,4.86,1.53,13.71,2.42,8.85-13.57,11.06-13.57,11.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M207.19,78.77s-13.26,4.98-13.15,21.96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M206.91,123.77s-4.35.57-7.55,5.69-4.84,14.01-4.84,14.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M212.68,158.95s-.35,2.16.83,3.94c1.56,2.36,4.21,2.12,4.21,2.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M265.11,138.38s0,4.39,2.23,5.4,3.7,1.63,6.04,1.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M323.76,76.17s2.45-14.14,16.02-17.34,24.36,7.02,23.6,18.1c-.76,11.08-16.25,16.19-16.25,25.54s.79,12.93-3.56,12.93-5.11-1.53-4.35-12.93,11.95-16.47,14.33-21.58c5.28-11.34-5.09-17.41-12.63-13.45s-8.24,10.07-10.56,11.34c-2.83,1.55-5.66,1.73-6.6-2.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M339.72,124.03c.25-3.25,1.7-3.58,3.86-3.7s4.34,1.69,3.49,4.7-1.92,2.65-3.49,2.65-3.99-2.05-3.86-3.65Z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_10",
    "data-name": "Layer 10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M66.84,299.39s9.34,12.99,17.17,11.05,31.72-11.15,31.72-11.15l10.38,4.91,12.98-12.97s20.3-7.6,24.41-7.21,11.33,1.4,11.33,1.4c-5.88-17.87-12.05-50.6-12.05-50.6,0,0-16.74,12.36-20.85,13.15s-15.85,5.96-15.85,5.96c0,0-5.64,2.95-6.23,3.7s-11.42,1.15-11.42,1.15l-41.57,40.62h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M165.58,236.14s1.37,48.54-7,23.02c-.82-2.49-2.18,4.81-2.18,4.81l-17.32,27.26,26.1-7.03,10.68,2.95-10.28-51h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M105.49,270.44s8.09-11.36,15.34-8.01c2.64,1.22,2.63,3,2.63,3l.08-8.57s-11.92,1.81-11.93,2.31-6.12,11.27-6.12,11.27h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M147.99,277.2s-27.77,21.34-28.05,14.03,2.65-14.03,2.65-14.03c0,0-13.23,22.11-23.22,24.88s-26.79,5.68-31.19,2.12,9.19,10.47,12.51,8.36,34.2-11.84,34.2-11.84l12.94,4.54,20.17-28.05h-.01Z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Arm"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M165.33,232.72s-20.11,16.32-36.57,17.15c-6.73.34-3.37,21.16-7.06,29.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M125.31,253.39s-8.2,5.77-14.71,3.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M157.49,259.16s-24.4,46.25-30.34,46.25-9.92-4.17-12.26-4.17-31.4,14.72-39.19,10.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M178.32,288.39s-7.83-5.29-18.9-1.76-21.99,8.18-21.99,8.18"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Forearm_Colour",
    "data-name": "Forearm Colour"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M91.68,178.55s11,11.94,13.13,11.67c0,0,11.69-27.97,18.07-33.82,0,0,13.17.96,19.55-9.94s13.55-21.8,13.55-21.8l-1.43-4.39s-5.14,9.93-10.36,6.79c-3.4-2.04-5.7-12.69-.5-19.01,2.8-3.4,14.27-4.66,14.27-4.66,0,0,11.74-9.82,9.75-13.65s-7.67-7.43-7.67-7.43l-13.87-2.49-22.46,17.06s-5.61,23.03-9.57,26.89-12.9,20.45-12.9,20.45c0,0-2.34,31.87-9.57,34.33h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M119.13,152.5s-17.06,35-18.96,34.82l6.2,3.79s14.16-33.74,16.52-34.7c0,0,14.54-1.67,16.55-5.03s14.49-23.52,15.53-25.11,0-4.76,0-4.76c0,0-7.82,5.24-10.76,4.55-5.88-1.37-2.61-12.42-.97-17.11,0,0,4.23-3.36,5.85-3.26s7.8-.33,7.8-.33l5.48,3.21,4.43-1.52-3.37-4.41s-3.65,4.48-15.22.17l-12.2,4.74s-8.53,31.48-11.71,34.59c-4,3.93-13.13,6.21-13.13,6.21,0,0,7.96,4.15,7.96,4.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M131.23,98.82s16.68-9.15,16.86-10.58,15.43,3.41,16.59,3.23,3.27.63,3.27.63l.41,7.62-8.16.36-14.13-3.57-14.84,2.32h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M107.8,253.39s3.93,8.11-1.31,14.22-17.17,17.46-19.35,21.39-18.49,11.56-20.3,10.39-12.44-12.76-9.38-28.16,8.17-45.68,8.17-45.68c0,0-.77-15.05,1.57-19.56s6.64-5.31,6.64-5.31l5.75-18.21s1.05-13.31,1.83-16.35,15.63-8.8,15.63-8.8l-7.29,19.21s6.56,13.7,10.41,15.5,9.05.74,9.05.74l13.1-30.06s9.96,9,6.96,15.85-10.15,18.64-10.15,18.64c0,0,.91,8.68-1.57,10.23s-5.22,4.61-5.22,4.61c0,0,1.94,13.08-1.73,18.03s1,9.25,1,9.25l-3.8,14.07h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "95.83 163.4 89.1 165.58 90.69 174.07 95.83 163.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M117.56,170.36c-.81.19-7.62,20.75-7.62,20.75,0,0,7.83-4.34,9.19-8.44s-1.57-12.3-1.57-12.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M97.32,220.06s.02,14.85-2.99,16.36-18.62-10.87-18.62-10.87c0,0,5.06,19.15,10.81,21.41s11.95,4.57,7.62,10.66-6.78,6.35-6.78,6.35c0,0,19.17,3.37,16.1,10.17,0,0,4.74-6.93,4.95-15.37s0-10.82,0-10.82l1.53-14.08,2.73-18.61s-9.16,6.69-15.36,4.79h.01Z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Forearm"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M90.83,178.55s10.49-18.43,8.46-33.63c0,0,7.74-10.79,12.63-20.57s10.79-25.46,10.79-28.51c0,0,20.77-13.44,22.81-18.13,0,0,17.52,3.67,18.74,4.68s3.46,5.09,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M131.46,100.7s11.04.61,16.43-2.95c0,0,11.65,2.87,14.86,2.52,0,0,4.87,7.13,6.52,7.3,0,0-6.28,3.2-8.58,2.19s-2.44-4.31-5.75-4.31-6.61.29-6.61.29l-10.5,5.61s-6.24,32.92-8.08,33.79-8.45,6.04-10.61,6.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M137.02,99.88s10.6-8.69,12.06-8.69,12.85,2.32,13.62,3.19.48,5.21,3.09,6.32,4.77,0,4.77,0c-1.02-5.91-1.64-11.26-2.84-12.08-2.24-1.53-17.52-5.61-19.96-5.61s-20.16,12.02-20.16,12.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M144.19,109.44s-2.62,7-2.62,10.5,1.31,6.23,5.1,5.23,9.62-6.4,9.62-6.4c0,0,1.98,6.11-1.35,10.93s-8.64,12.89-11.63,18.6c-1.72,3.29-13.79,11.46-18.77,9.3,0,0-10.83,14.33-16.15,34.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M96.17,161.98s-4.67-1.27-7.48,4.35c-4.3,8.61,16.13,38.03,29.67,21.47,7.1-8.68,0-19.32,0-19.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M97.48,156.4s-13.86-.54-17.38,10.94c-2.86,9.32.25,13.01-.64,15.96s-5.85,9.21-5.6,13.16c.61,9.83,15.23,25.73,26.73,22.52s16.33-8.72,18.62-12.76,1.68-9.03,1.68-9.03c0,0,18.21-20.33,2.24-35.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M75.7,311.89c-15.55-9.28-19.64-34.19-20.13-39.7-.48-5.52,9.61-46.63,9.61-46.63-3.85-26.65,9.36-25.98,9.36-25.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M114.36,212.04s1.34,8.29-.23,13.51-3.56,4.2-2.53,13.77-9.67,19.46-9.67,19.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M88.76,174.45s-4.16,1.22-4.38,4.29,1.77,9.99-1.37,14.84-5.63,8.16-5.46,12.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M97.32,187.31s-1.79,3.99-3.55,9.96-5.86,12.84-5.66,18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M109.89,193.08s-.25,2.29-2.78,6.6-2.59,17.12-5.53,19.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M121.7,183.3s6.57.89-3.34,10.7c-4.17,4.13-3.26,13.1-7.08,20.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M81.42,166.13s4.01-3.13,5.92.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M120.83,173.63s5.34-5.59,8.45,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M108.41,252.69s2.03-1.22,2.19,4.53-4.26,16.81-17.95,27.76"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrandmaconfused1);
export default __webpack_public_path__ + "static/media/grandma confused1.16a6ef61ca13808758ce0dc3d3cfbbad.svg";
export { ForwardRef as ReactComponent };